<div class="selector">
	@if (hasItems()) {
		<mat-select
			[placeholder]="filter().title"
			#selector
			(keyup.enter)="onEnterKey()"
			[value]="selectedValue()"
			[disabled]="disabled()"
			[ngClass]="{ 'disabled-select': disabled() }"
			panelClass="nha-selector"
			panelWidth="null"
		>
			@if (triggerLabel()) {
				<mat-select-trigger>{{ triggerLabel() }}</mat-select-trigger>
			}
			@for (item of filterItems(); track $index) {
				<mat-option
					nhaTest="selector-item"
					[value]="item.id"
					(click)="select(filterKey(), filter(), item.id)"
					[class.has-subtitle]="filterKey() === 'school' && (item.data?.city || item.data?.stateCode)"
				>
					{{ item.label }}
					@if (filterKey() === 'school' && (item.data?.city || item.data?.stateCode)) {
						<span
							class="option-subtitle"
							[attr.data-subtitle]="(item.data.city ?? '') + (item.data.city && item.data.stateCode ? ', ' : '') + (item.data.stateCode ?? '')"
						></span>
					}
				</mat-option>
			}
		</mat-select>
	} @else {
		<div class="single-value">
			{{ filterItems()[0]?.label }}
		</div>
	}
</div>
